import React, { useEffect, useState } from "react";
import Button from "../../extra/Button";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import Input from "../../extra/Input";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  updateCashoutRequest,
  processCashout,
} from "../../store/cashoutRequest/cashoutRequest.action";
import dayjs from "dayjs";
import { warning } from "../../../util/Alert";

const CashoutDialog = (props) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const [transactionRef, setTransactionRef] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [error, setError] = useState({
    transactionRef: "",
    rejectionReason: "",
  });
  const dispatch = useDispatch();

  const handleApprove = () => {
    const data = warning(
      "Approve",
      "Are you sure you want to approve this cashout request? Status will change to 'processing'."
    );
    data
      .then((isConfirmed) => {
        if (isConfirmed) {
          dispatch(updateCashoutRequest(dialogueData._id, "processing"));
          dispatch({ type: CLOSE_DIALOGUE });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleReject = () => {
    if (!rejectionReason) {
      return setError({ ...error, rejectionReason: "Please provide a rejection reason" });
    }

    const data = warning(
      "Reject",
      "Are you sure you want to reject this cashout request?"
    );
    data
      .then((isConfirmed) => {
        if (isConfirmed) {
          dispatch(updateCashoutRequest(dialogueData._id, "rejected", rejectionReason));
          dispatch({ type: CLOSE_DIALOGUE });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleProcess = () => {
    if (!transactionRef) {
      return setError({ ...error, transactionRef: "Transaction reference is required" });
    }

    const data = warning(
      "Complete",
      "Are you sure you want to mark this cashout as completed? This action cannot be undone."
    );
    data
      .then((isConfirmed) => {
        if (isConfirmed) {
          dispatch(processCashout(dialogueData._id, transactionRef));
          dispatch({ type: CLOSE_DIALOGUE });
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="mainDialogue fade-in">
      <div className="Dialogue" style={{ maxWidth: "700px" }}>
        <div className="dialogueHeader">
          <div className="headerTitle fw-bold text-white">Cashout Request Details</div>
          <div
            className="closeBtn "
            onClick={() => {
              dispatch({ type: CLOSE_DIALOGUE });
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div className="dialogueMain" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="row">
            {/* Request Details */}
            <div className="col-12 mb-3">
              <div className="card bg-dark text-white">
                <div className="card-body">
                  <h6 className="card-subtitle mb-3 text-muted">Request Information</h6>
                  <div className="row">
                    <div className="col-6 mb-2">
                      <small className="text-muted">Request Date</small>
                      <div className="fw-bold">
                        {dayjs(dialogueData?.createdAt).format("DD MMM YYYY, HH:mm")}
                      </div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Status</small>
                      <div>
                        <span className={`badge ${
                          dialogueData?.status === "pending" ? "bg-warning text-dark" :
                          dialogueData?.status === "processing" ? "bg-info" :
                          dialogueData?.status === "completed" ? "bg-success" :
                          "bg-danger"
                        }`}>
                          {dialogueData?.status}
                        </span>
                      </div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Coins Amount</small>
                      <div className="fw-bold text-info">{dialogueData?.coinAmount} coins</div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Requested Amount</small>
                      <div className="fw-bold">GHS {dialogueData?.requestedAmount?.toFixed(2)}</div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Processing Fee (5%)</small>
                      <div className="text-danger">-GHS {dialogueData?.processingFee?.toFixed(2)}</div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Final Payout Amount</small>
                      <div className="fw-bold text-success fs-5">GHS {dialogueData?.finalAmount?.toFixed(2)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Creator Details */}
            <div className="col-12 mb-3">
              <div className="card bg-dark text-white">
                <div className="card-body">
                  <h6 className="card-subtitle mb-3 text-muted">Creator Information</h6>
                  <div className="row">
                    <div className="col-6 mb-2">
                      <small className="text-muted">Name</small>
                      <div className="fw-bold">
                        {dialogueData?.userId?.name || dialogueData?.userId?.shopName || "N/A"}
                      </div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Type</small>
                      <div className="badge bg-secondary">{dialogueData?.userType}</div>
                    </div>
                    <div className="col-12 mb-2">
                      <small className="text-muted">Contact</small>
                      <div>{dialogueData?.userId?.email || "N/A"}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bank Details */}
            <div className="col-12 mb-3">
              <div className="card bg-dark text-white">
                <div className="card-body">
                  <h6 className="card-subtitle mb-3 text-muted">Bank Details</h6>
                  <div className="row">
                    <div className="col-12 mb-2">
                      <small className="text-muted">Bank Name</small>
                      <div className="fw-bold">{dialogueData?.bankDetails?.bankName}</div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Account Number</small>
                      <div className="fw-bold">{dialogueData?.bankDetails?.accountNumber}</div>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted">Account Name</small>
                      <div className="fw-bold">{dialogueData?.bankDetails?.accountName}</div>
                    </div>
                    {dialogueData?.bankDetails?.branchCode && (
                      <div className="col-6 mb-2">
                        <small className="text-muted">Branch Code</small>
                        <div>{dialogueData?.bankDetails?.branchCode}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Actions based on status */}
            {dialogueData?.status === "pending" && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label className="text-white mb-2">Rejection Reason (if rejecting)</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={rejectionReason}
                    placeholder="Enter reason for rejection"
                    onChange={(e) => {
                      setRejectionReason(e.target.value);
                      setError({ ...error, rejectionReason: "" });
                    }}
                    style={{
                      backgroundColor: "#2d2d2d",
                      color: "white",
                      border: "1px solid #444",
                      padding: "10px"
                    }}
                  />
                  {error.rejectionReason && (
                    <small className="text-danger">{error.rejectionReason}</small>
                  )}
                </div>
              </div>
            )}

            {dialogueData?.status === "processing" && (
              <div className="col-12">
                <Input
                  label={`Transaction Reference (Required to complete)`}
                  id={`transactionRef`}
                  type={`text`}
                  value={transactionRef}
                  placeholder={`Enter Paystack/Bank transaction reference`}
                  errorMessage={error.transactionRef && error.transactionRef}
                  onChange={(e) => {
                    setTransactionRef(e.target.value);
                    setError({ ...error, transactionRef: "" });
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="dialogueFooter">
          <div className="dialogueBtn">
            {dialogueData?.status === "pending" && (
              <>
                <Button
                  btnName={`Approve`}
                  btnColor={`bg-success text-light`}
                  style={{ borderRadius: "5px", width: "100px" }}
                  newClass={`me-2`}
                  onClick={handleApprove}
                />
                <Button
                  btnName={`Reject`}
                  btnColor={`bg-danger text-light`}
                  style={{ borderRadius: "5px", width: "100px" }}
                  newClass={`me-2`}
                  onClick={handleReject}
                />
              </>
            )}
            {dialogueData?.status === "processing" && (
              <Button
                btnName={`Complete`}
                btnColor={`bg-primary text-light`}
                style={{ borderRadius: "5px", width: "100px" }}
                newClass={`me-2`}
                onClick={handleProcess}
              />
            )}
            <Button
              btnName={`Close`}
              btnColor="myCustomButton"
              style={{ borderRadius: "5px", width: "80px" }}
              onClick={() => {
                dispatch({ type: CLOSE_DIALOGUE });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { updateCashoutRequest, processCashout })(
  CashoutDialog
);
